<div class="app-sub-header">
    <div class="container">
        <div class="grid">
            <div class="col-12 md:col-6">
                <h1 class="page-title red-color">Customer Specification</h1>
            </div>
            <div class="col-12 md:col-6 flex">
                <eon-ui-link
                    class="download-link"
                    href="/assets/UserGuide_CollaborativeBuildingManagementDashboards_V2.1 2.pdf"
                    text="Download User Guide"
                    download="true"
                    scheme="turquoise"
                ></eon-ui-link>
            </div>
        </div>

        <div class="flex align-items-center gap-3">
            <p-select
                class="dd_min-width"
                [options]="customerList"
                [(ngModel)]="selectedCustomer"
                [filter]="true"
                filterBy="label,name"
                placeholder="Customers"
                optionLabel="name"
                [disabled]="isEditMode"
                (onChange)="onCustomerChosen()"
            >
            </p-select>
            @if (userHasWritePermission) {
                <eon-ui-button
                    class="margin-right-05"
                    size="small"
                    scheme="turquoise"
                    (click)="activateEditMode()"
                    [disabled]="!selectedCustomer?.id"
                    text="Edit"
                ></eon-ui-button>
            }
        </div>
    </div>
</div>
<div class="main-wrapper">
    <div class="container">
        <div class="grid">
            @if (!isEditMode) {
                <div class="col-12 spec-container">
                        <div class="text-section">
                            @if (!customerSpecificationsText) {
                                <h2>
                                    No specifications found.
                                </h2>
                            }
                            @if (customerSpecificationsText) {
                                <span class="ql-editor">
                                    <div [innerHTML]="customerSpecificationsText | safeHtml"></div>
                                </span>
                            }
                        </div>
                </div>
            }
            @if (isEditMode) {
                <div class="col-12 spec-container editor-container">
                    <cc-text-editor [(htmlStr)]="specificationsTextToSave"></cc-text-editor>
                </div>
                <div class="col-12 flex justify-content-end gap-3">
                    <eon-ui-button
                        size="small"
                        scheme="turquoise"
                        (click)="save()"
                        [disabled]="!specificationsTextToSave || specificationsTextToSave?.length === 0"
                        text="Save"
                    ></eon-ui-button>
                    <eon-ui-button
                        size="small"
                        scheme="turquoise"
                        (click)="cancel()"
                        text="Cancel"
                    ></eon-ui-button>
                </div>
            }
        </div>
    </div>
</div>
